

document.addEventListener('DOMContentLoaded', function () {
  let loading = false;
  let nextPage = 2;

  const productGrid = document.querySelector('#product-grid');
  if (!productGrid) return;

  const loadMoreProducts = async () => {
    if (loading) return;
    loading = true;

    const nextUrl = `${window.location.pathname}?page=${nextPage}`;

    try {
      const response = await fetch(nextUrl);
      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');

      const newProducts = doc.querySelectorAll('#product-grid > li');
      if (newProducts.length === 0) return;

      newProducts.forEach((item) => {
        productGrid.appendChild(item);
      });

      nextPage++;
      loading = false;
    } catch (err) {
      console.error('Infinite scroll error:', err);
      loading = false;
    }
  };

  window.addEventListener('scroll', () => {
    const scrollPosition = window.innerHeight + window.scrollY;
    const pageHeight = document.body.offsetHeight;

    if (scrollPosition >= pageHeight - 300) {
      loadMoreProducts();
    }
  });
});
